var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.barChartVisitacaoHorario.chartData.labels.length > 0)?_c('div',{style:(`min-width:${
    _vm.barChartVisitacaoHorario.chartData.labels.length * 8
  }px;max-width:100%;`)},[_c('bar-chart',{attrs:{"id":"pie-chart-size","height":_vm.height,"chart-data":_vm.barChartVisitacaoHorario.chartData,"extra-options":_vm.barChartVisitacaoHorario.extraOptions}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }